export default __webpack_public_path__ + "static/media/DNo.37-4.7690e7bc.jpg";